document.addEventListener("shopify:section:load", function () {
  var elem = document.querySelector(".press-slider");
  if (elem) {
    new Flickity(elem, {
      wrapAround: true,
      autoPlay: 5000,
      pageDots: true,
      prevNextButtons: false,
    });
  }
});

document.addEventListener("shopify:section:load", function () {
  var elem = document.querySelector(".atheletes-slider-outer");
  if (elem) {
    new Flickity(elem, {
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      cellAlign: "center",
      contain: false,
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let slides = document.querySelectorAll(".flickity-slider .slide");

  function updateClasses() {
    slides.forEach((slide) =>
      slide.classList.remove("first-two", "last-two", "fixed-slide")
    );

    if (slides.length >= 4) {
      slides[0].classList.add("first-two", "fixed-slide");
      slides[1].classList.add("first-two", "fixed-slide");
      slides[slides.length - 2].classList.add("last-two", "fixed-slide");
      slides[slides.length - 1].classList.add("last-two", "fixed-slide");
    }
  }

  updateClasses();
  const observer = new MutationObserver(updateClasses);
  // observer.observe(document.querySelector(".flickity-slider"), { childList: true });
});

document.addEventListener("DOMContentLoaded", function () {
  const marquee = document.querySelector(".marquee");

  if (marquee) {
    // Check if marquee element exists
    marquee.innerHTML += marquee.innerHTML;

    const marqueeWidth = marquee.offsetWidth;

    function animateMarquee() {
      let startPosition = 0;
      const speed = 0.5;

      function step() {
        startPosition -= speed;
        // Reset start position to ensure a smooth continuous loop
        if (Math.abs(startPosition) >= marqueeWidth / 3) {
          startPosition = 0;
        }
        marquee.style.transform = `translateX(${startPosition}px)`;
        requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    animateMarquee();
  }
});

jQuery(document).ready(function ($) {
  $(document).on("click", 'a[href^="#"]', function (event) {
    event.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $($.attr(this, "href")).offset().top,
      },
      1000
    );
  });

// var $bottomTexts = $('.bottom-texts');
// var $navLinks = $('.bottom-texts a');
// var $standardSec = $('#standard_sec');
// var $aussieKidsSection = $('#aussie_kids');
// var lastScrollTop = 0;
// var ticking = false;

// function handleScroll() {
//     var scrollPosition = $(window).scrollTop();
//     var currentSection = '';
    
//     // Check if .bottom-texts should be active
//     if ($bottomTexts.length) {
//         var bottomOffset = $bottomTexts.offset().top;
//         if (scrollPosition >= bottomOffset) {
//             $bottomTexts.addClass('active');
//         } else {
//             $bottomTexts.removeClass('active');
//         }
//     }

//     // Check if inside standard_sec
//     if ($standardSec.length) {
//         var standardTop = $standardSec.offset().top;
//         var standardBottom = standardTop + $standardSec.outerHeight();
//         if (scrollPosition >= standardTop && scrollPosition < standardBottom) {
//             $bottomTexts.addClass('active');
//         }
//     }

//     // Remove active class if reached aussie_kids section
//     if ($aussieKidsSection.length) {
//         var aussieTop = $aussieKidsSection.offset().top;
//         if (scrollPosition >= aussieTop) {
//             $bottomTexts.removeClass('active');
//         }
//     }

//     // Update active link based on scroll position
//     $navLinks.each(function () {
//         var sectionId = $(this).attr('href');
//         if (sectionId && sectionId.startsWith('#')) {
//             var $section = $(sectionId);
//             if ($section.length) {
//                 var sectionTop = $section.offset().top - 50;
//                 var sectionBottom = sectionTop + $section.outerHeight();

//                 if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
//                     currentSection = sectionId;
//                 }
//             }
//         }
//     });

//     $navLinks.removeClass('active');
//     if (currentSection) {
//         $('.bottom-texts a[href="' + currentSection + '"]').addClass('active');
//     }

//     // Remove active class when scrolling up
//     if (scrollPosition < lastScrollTop) {
//         $bottomTexts.removeClass('active');
//     }

//     lastScrollTop = scrollPosition;
//     ticking = false;
// }

// // Use requestAnimationFrame for smooth updates
// $(window).on('scroll', function () {
//     if (!ticking) {
//         requestAnimationFrame(handleScroll);
//         ticking = true;
//     }
// });

  
});

// document.addEventListener("DOMContentLoaded", function () {
//   const accordions = document.querySelectorAll(".accordion details");
//   accordions.forEach((accordion) => {
//     accordion.addEventListener("click", function (event) {
//       accordions.forEach((item) => {
//         if (item !== accordion) {
//           item.removeAttribute("open");
//         }
//       });
//     });
//   });
// });


// // function toggleAccordion(clickedItem) {
// //   const parentSection = clickedItem.closest(".accordion-section");
// //   const allItems = parentSection.querySelectorAll(".accordion-item");

// //   allItems.forEach((item) => {
// //     if (item.querySelector(".accordion-question") !== clickedItem) {
// //       item.classList.remove("active");
// //       item.querySelector(".accordion-content").style.display = "none";
// //     }
// //   });

// //   const parentItem = clickedItem.parentElement;
// //   const content = parentItem.querySelector(".accordion-content");

// //   if (parentItem.classList.contains("active")) {
// //     parentItem.classList.remove("active");
// //     content.style.display = "none";
// //   } else {
// //     parentItem.classList.add("active");
// //     content.style.display = "block";
// //   }
// // }

// right menu active js

document.addEventListener('DOMContentLoaded', function() {
  const currentPath = window.location.pathname;
  const menuLinks = document.querySelectorAll('.right_menu_item a');
  menuLinks.forEach(function(link) {
    const linkPath = new URL(link.href).pathname;
    if (currentPath === linkPath) {
      link.classList.add('active');
    }
  });
});

